import {useEnvironment} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React, {PropsWithChildren} from 'react'
import {SummaryContainerProps} from './interfaces'
import s from './summary-container.scss'

export const SummaryContainer = ({
  inTickets,
  inAccessibilityMode,
  children,
}: PropsWithChildren<SummaryContainerProps>) => {
  const {isMobile} = useEnvironment()
  const mobileInTickets = isMobile && inTickets
  const mobileAccessibilityMode = isMobile && inAccessibilityMode

  return (
    <div
      className={classNames(s.container, {
        [s.stickyContainer]: mobileInTickets || mobileAccessibilityMode,
      })}
    >
      {children}
    </div>
  )
}
